<template>
  <div>
    <b-form>
      <div class="row mb-3">
        <div class="col-md-6 mb-3">
          <label for="provinsi">Provinsi</label>
          <v-select
            id="provinsi"
            v-model="form.provinsi_perubahan"
            :reduce="(data) => data.nama_provinsi"
            label="nama_provinsi"
            :options="dataProvinsi"
            name="Provinsi"
            v-validate="'required'"
          />
          <span class="text-danger" v-if="errors.has('Provinsi')">
            {{ errors.first('Provinsi') }}
          </span>
        </div>
        <div class="col-md-6 mb-3">
          <label for="kabupaten">Kabupaten</label>
          <v-select
            id="kabupaten"
            v-model="form.kabupaten_perubahan"
            :reduce="(data) => data.nama_kabupaten"
            label="nama_kabupaten"
            :options="dataKabupaten"
            name="Kabupaten"
            v-validate="'required'"
          />
          <span class="text-danger" v-if="errors.has('Kabupaten')">
            {{ errors.first('Kabupaten') }}
          </span>
        </div>
        <div class="col-md-6 mb-3">
          <label for="kecamatan">Kecamatan</label>
          <v-select
            id="kecamatan"
            v-model="form.kecamatan_perubahan"
            :reduce="(data) => data.nama_kecamatan"
            label="nama_kecamatan"
            :options="dataKecamatan"
            name="Kecamatan"
            v-validate="'required'"
          />
          <span class="text-danger" v-if="errors.has('Kecamatan')">
            {{ errors.first('Kecamatan') }}
          </span>
        </div>
        <div class="col-md-6 mb-3">
          <label for="nama_perairan">Nama Perairan</label>
          <b-form-input
            id="nama_perairan"
            v-model="form.nama_perairan_perubahan"
            v-validate="'required'"
            name="Nama Perairan"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('Nama Perairan')">
            {{ errors.first('Nama Perairan') }}
          </span>
        </div>
        <div class="col-md-6 mb-3">
          <label for="garis_pantai">Garis Pantai</label>
          <b-form-input
            id="garis_pantai"
            v-model="form.garis_pantai_perubahan"
            v-validate="'required'"
            name="Garis Pantai"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('Garis Pantai')">
            {{ errors.first('Garis Pantai') }}
          </span>
        </div>
        <div class="col-md-6 mb-3">
          <label for="kedalaman">Kedalaman (m)</label>
          <b-form-input
            id="kedalaman"
            v-model="form.kedalaman_perubahan"
            v-validate="'required'"
            name="Kedalaman"
            type="number"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('Kedalaman')">
            {{ errors.first('Kedalaman') }}
          </span>
        </div>
        <div class="col-md-6 mb-3">
          <label for="jenis_permohonan">Jenis Permohonan</label>
          <v-select
            id="jenis_permohonan"
            v-model="form.jenis_pnbp_perubahan"
            :options="[
              'Area',
              'Kabel Bawah Laut',
              'Pipa Air Bersih / Air Baku',
              'Pipa Selain Air Bersih / Air Baku',
            ]"
            name="Jenis Permohonan"
            v-validate="'required'"
            multiple
          />
          <span class="text-danger" v-if="errors.has('Jenis Permohonan')">
            {{ errors.first('Jenis Permohonan') }}
          </span>
        </div>
        <div
          v-if="form.jenis_pnbp_perubahan.includes('Area')"
          class="col-md-6 mb-3"
        >
          <label for="luas">Luas (ha)</label>
          <b-form-input
            id="luas"
            v-model="form.luas_perubahan"
            name="Luas"
            type="number"
            v-validate="'required'"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('Luas')">
            {{ errors.first('Luas') }}
          </span>
        </div>
        <div
          v-if="form.jenis_pnbp_perubahan.includes('Kabel Bawah Laut')"
          class="col-md-6 mb-3"
        >
          <label for="panjang_konservasi_kabel">
            Panjang Kabel (di dalam Kws. Konservasi) (km)
          </label>
          <b-form-input
            id="panjang_konservasi_kabel"
            v-model="form.panjang_konservasi_kabel_perubahan"
            name="Panjang Kabel (Dalam Kawasan)"
            type="number"
            v-validate="'required'"
          ></b-form-input>
          <span
            class="text-danger"
            v-if="errors.has('Panjang Kabel (Dalam Kawasan)')"
          >
            {{ errors.first('Panjang Kabel (Dalam Kawasan)') }}
          </span>
        </div>
        <div
          v-if="form.jenis_pnbp_perubahan.includes('Kabel Bawah Laut')"
          class="col-md-6 mb-3"
        >
          <label for="panjang_nonkonservasi_kabel">
            Panjang Kabel (di luar Kws. Konservasi) (km)
          </label>
          <b-form-input
            id="panjang_nonkonservasi_kabel"
            v-model="form.panjang_nonkonservasi_kabel_perubahan"
            name="Panjang Kabel (Luar Kawasan)"
            type="number"
            v-validate="'required'"
          ></b-form-input>
          <span
            class="text-danger"
            v-if="errors.has('Panjang Kabel (Luar Kawasan)')"
          >
            {{ errors.first('Panjang Kabel (Luar Kawasan)') }}
          </span>
        </div>
        <div
          v-if="
            form.jenis_pnbp_perubahan.includes('Pipa Air Bersih / Air Baku')
          "
          class="col-md-6 mb-3"
        >
          <label for="panjang_konservasi_pipa_air">
            Panjang Pipa Air Bersih (di dalam Kws. Konservasi) (km)
          </label>
          <b-form-input
            id="panjang_konservasi_pipa_air"
            v-model="form.panjang_konservasi_pipa_air_perubahan"
            name="Panjang Pipa (Dalam Kawasan)"
            type="number"
            v-validate="'required'"
          ></b-form-input>
          <span
            class="text-danger"
            v-if="errors.has('Panjang Pipa (Dalam Kawasan)')"
          >
            {{ errors.first('Panjang Pipa (Dalam Kawasan)') }}
          </span>
        </div>
        <div
          v-if="
            form.jenis_pnbp_perubahan.includes('Pipa Air Bersih / Air Baku')
          "
          class="col-md-6 mb-3"
        >
          <label for="panjang_nonkonservasi_pipa_air">
            Panjang Pipa Air Bersih (di luar Kws. Konservasi) (km)
          </label>
          <b-form-input
            id="panjang_nonkonservasi_pipa_air"
            v-model="form.panjang_nonkonservasi_pipa_air_perubahan"
            name="Panjang Pipa (Luar Kawasan)"
            type="number"
            v-validate="'required'"
          ></b-form-input>
          <span
            class="text-danger"
            v-if="errors.has('Panjang Pipa (Luar Kawasan)')"
          >
            {{ errors.first('Panjang Pipa (Luar Kawasan)') }}
          </span>
        </div>
        <div
          v-if="
            form.jenis_pnbp_perubahan.includes(
              'Pipa Selain Air Bersih / Air Baku',
            )
          "
          class="col-md-6 mb-3"
        >
          <label for="panjang_konservasi_pipa_lain">
            Panjang Pipa Selain Air Bersih (di dalam Kws. Konservasi) (km)
          </label>
          <b-form-input
            id="panjang_konservasi_pipa_lain"
            v-model="form.panjang_konservasi_pipa_lain_perubahan"
            name="Panjang Pipa Selain Air Bersih (Dalam Kawasan)"
            type="number"
            v-validate="'required'"
          ></b-form-input>
          <span
            class="text-danger"
            v-if="errors.has('Panjang Pipa Selain Air Bersih (Dalam Kawasan)')"
          >
            {{ errors.first('Panjang Pipa Selain Air Bersih (Dalam Kawasan)') }}
          </span>
        </div>
        <div
          v-if="
            form.jenis_pnbp_perubahan.includes(
              'Pipa Selain Air Bersih / Air Baku',
            )
          "
          class="col-md-6 mb-3"
        >
          <label for="panjang_nonkonservasi_pipa_lain">
            Panjang Pipa Selain Air Bersih (di luar Kws. Konservasi) (km)
          </label>
          <b-form-input
            id="panjang_nonkonservasi_pipa_lain"
            v-model="form.panjang_nonkonservasi_pipa_lain_perubahan"
            name="Panjang Pipa Selain Air Bersih (Luar Kawasan)"
            type="number"
            v-validate="'required'"
          ></b-form-input>
          <span
            class="text-danger"
            v-if="errors.has('Panjang Pipa Selain Air Bersih (Luar Kawasan)')"
          >
            {{ errors.first('Panjang Pipa Selain Air Bersih (Luar Kawasan)') }}
          </span>
        </div>
        <div class="col-12 mb-3">
          <label for="rencana_detail_kegiatan">Rencana Detail Kegiatan</label>
          <ckeditor
            :editor="wygEditor"
            v-model="form.rencana_detail_kegiatan_perubahan"
          ></ckeditor>
          <span
            class="text-danger"
            v-if="errors.has('Rencana Detail Kegiatan')"
          >
            {{ errors.first('Rencana Detail Kegiatan') }}
          </span>
        </div>
      </div>
    </b-form>

    <div class="mb-4">
      <legend>
        <strong>Hasil Analisis</strong>
      </legend>
      <div>
        <ckeditor
          :editor="wygEditor"
          v-model="formBaPentek.hasil_verifikasi_teknis"
        ></ckeditor>
        <span class="text-danger" v-if="errors.has('Hasil Analisis')">
          {{ errors.first('Hasil Analisis') }}
        </span>
      </div>
    </div>

    <div class="mb-4">
      <legend>
        <strong>Tanda Tangan</strong>
      </legend>
      <div class="row mb-2">
        <div class="col-lg-4">
          <label for="ttd_ba_vertek_1">Direktur</label>
          <v-select
            id="ttd_ba_vertek_1"
            v-model="formBaPentek.ttd_ba_vertek_1"
            :reduce="(data) => data.id_user"
            label="nama_lengkap"
            :options="ttdDirektur"
            name="TTD Direktur"
            v-validate="'required'"
          />
          <span class="text-danger" v-if="errors.has('TTD Direktur')">
            {{ errors.first('TTD Direktur') }}
          </span>
        </div>
        <div class="col-lg-4">
          <label for="ttd_ba_vertek_2">Ketua Tim</label>
          <v-select
            id="ttd_ba_vertek_2"
            v-model="formBaPentek.ttd_ba_vertek_2"
            :reduce="(data) => data.id_user"
            label="nama_lengkap"
            :options="ttdKetuaTim"
            name="TTD Ketua Tim"
            v-validate="'required'"
          />
          <span class="text-danger" v-if="errors.has('TTD Ketua Tim')">
            {{ errors.first('TTD Ketua Tim') }}
          </span>
        </div>
        <div class="col-lg-4">
          <label for="ttd_ba_vertek_4">Pimpinan Rapat</label>
          <v-select
            id="ttd_ba_vertek_4"
            v-model="formBaPentek.ttd_ba_vertek_4"
            :reduce="(data) => data.id_user"
            label="nama_lengkap"
            :options="ttdPimpinanRapat"
            name="TTD Pimpinan Rapat"
            v-validate="'required'"
          />
          <span class="text-danger" v-if="errors.has('TTD Pimpinan Rapat')">
            {{ errors.first('TTD Pimpinan Rapat') }}
          </span>
        </div>
      </div>
    </div>

    <div class="mb-2">
      <legend>
        <strong>Koordinat Setelah Perubahan</strong>
      </legend>
      <div class="row mb-2">
        <div class="col-lg-8">
          <b-button variant="success" @click="$bvModal.show('modal-koordinat')">
            <i class="fa fa-plus"></i> Tambah
          </b-button>
          <b-button
            variant="primary"
            class="ms-2"
            @click="toggleModalImportKoordinat(true)"
          >
            <i class="fa fa-file-excel-o"></i> Import
          </b-button>
        </div>
        <div class="col-lg-4">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
            <label class="d-inline-flex align-items-center">
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search..."
                class="form-control form-control-sm"
              ></b-form-input>
            </label>
          </div>
        </div>
      </div>
      <div class="table-responsive mb-0 datatables">
        <b-table
          striped
          hover
          :items="itemsWithNumber"
          :fields="fields"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(aksi)="data">
            <b-button
              variant="info"
              size="sm"
              @click="editKoordinat(data.item)"
            >
              <i class="fa fa-pencil-square-o"></i> Edit
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              class="ms-1 text-white"
              @click="deleteKoordinat(data.item)"
            >
              <i class="fa fa-trash-o"></i> Hapus
            </b-button>
          </template>
        </b-table>
      </div>
      <div class="row mb-2">
        <div class="col-lg-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              <b-form-select
                class="form-control form-control-sm form-select form-select-sm"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
            </label>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <legend><strong>File Lampiran</strong></legend>
      <div class="row mb-2">
        <div class="col-lg-6">
          <label for="file_lampiran"> File Lampiran Peta: </label>
          <div class="d-flex gap-2 mb-2">
            <b-form-file
              id="file_lampiran"
              v-model="file_peta"
              plain
              multiple
              class="form-control"
            ></b-form-file>
            <b-button
              variant="primary"
              class="text-white"
              size="sm"
              @click="uploadFilePeta"
              :disabled="!file_peta || (file_peta && !file_peta.length)"
            >
              <i class="fa fa-upload"></i> Unggah File
            </b-button>
          </div>
          <ul class="list-group" v-if="file_peta_pv?.length">
            <li
              v-for="(file, index) in file_peta_pv"
              :key="index"
              class="list-group-item d-flex align-items-center justify-content-between"
            >
              <div class="me-3 fw-bold" style="width: 30px">
                {{ index + 1 }}.
              </div>
              <div class="flex-grow-1 text-truncate">
                {{ file.label }}
              </div>
              <div class="d-flex gap-2">
                <!-- <button class="btn btn-sm btn-danger text-white">
                  <i class="glyphicon glyphicon-trash pb-2"></i>
                </button> -->
                <a
                  :href="file.value"
                  class="btn btn-sm btn-primary text-white"
                  target="_blank"
                >
                  <i class="glyphicon glyphicon-download pb-2"></i>
                </a>
              </div>
            </li>
          </ul>
          <template v-else>
            <span>Tidak ada lampiran!</span>
          </template>
        </div>
      </div>
    </div>

    <b-modal
      body-class="bg-white"
      id="modal-koordinat"
      :title="editKoordinatId ? 'Edit Data Kordinat' : 'Tambah Data Kordinat'"
    >
      <form>
        <b-form-group label="Nama Titik" label-for="nama_titik" class="mb-3">
          <b-form-input
            v-validate="'required'"
            name="Nama Titik"
            id="nama_titik"
            v-model="formKoordinat.nama_titik"
          />
          <span class="text-danger" v-if="errors.has('Nama Titik')">
            {{ errors.first('Nama Titik') }}
          </span>
        </b-form-group>
        <b-form-group label="Bujur" label-for="bujur" class="mb-3">
          <b-form-input
            v-validate="'required'"
            name="Bujur"
            id="bujur"
            v-model="formKoordinat.bujur"
          />
          <span class="text-danger" v-if="errors.has('Bujur')">
            {{ errors.first('Bujur') }}
          </span>
        </b-form-group>
        <b-form-group label="Lintang" label-for="lintang" class="mb-3">
          <b-form-input
            v-validate="'required'"
            name="Lintang"
            id="lintang"
            v-model="formKoordinat.lintang"
          />
          <span class="text-danger" v-if="errors.has('Lintang')">
            {{ errors.first('Lintang') }}
          </span>
        </b-form-group>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            style="float: right"
            @click="submitKoordinat"
          >
            <span class="text-white">Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      body-class="bg-white"
      id="modal-import-koordinat"
      title="Import Koordinat"
    >
      <form>
        <b-form-group label="File (.xlxs)" label-for="file" class="mb-3">
          <b-form-file
            plain
            v-validate="'required'"
            name="File"
            id="file"
            v-model="formImportKoordinat.file"
            accept=".xlsx"
            class="form-control"
          />
          <span class="text-danger" v-if="errors.has('File')">
            {{ errors.first('File') }}
          </span>
        </b-form-group>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            style="float: right"
            @click="submitImportKoordinat"
          >
            <span class="text-white">Import</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
import vSelect from 'vue-select'
import axios from 'axios'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Swal from 'sweetalert2'

export default {
  components: { vSelect },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      form: {
        provinsi_perubahan: null,
        kabupaten_perubahan: null,
        kecamatan_perubahan: null,
        nama_perairan_perubahan: null,
        garis_pantai_perubahan: null,
        jenis_pnbp_perubahan: [],
        luas_perubahan: null,
        panjang_konservasi_kabel_perubahan: null,
        panjang_nonkonservasi_kabel_perubahan: null,
        panjang_konservasi_pipa_air_perubahan: null,
        panjang_nonkonservasi_pipa_air_perubahan: null,
        panjang_konservasi_pipa_lain_perubahan: null,
        panjang_nonkonservasi_pipa_lain_perubahan: null,
        kedalaman_perubahan: null,
        rencana_detail_kegiatan_perubahan: null,
      },
      formBaPentek: {
        hasil_verifikasi_teknis: null,
        ttd_ba_vertek_1: null,
        ttd_ba_vertek_2: null,
        ttd_ba_vertek_4: null,
        pimpinan_rapat: 'ttd_ba_vertek_4',
      },
      file_peta_pv: null,
      file_peta: null,
      dataPermohonan: {},
      formKoordinat: {
        nama_titik: '',
        bujur: '',
        lintang: '',
      },
      editKoordinatId: null,
      formImportKoordinat: {
        file: null,
      },
      fields: ['no', 'nama_titik', 'bujur', 'lintang', 'aksi'],
      dataKordinat: [],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'name',
      sortDesc: false,
      wygEditor: ClassicEditor,
      dataProvinsi: [],
      selectedProvinsi: null,
      dataKabupaten: [],
      selectedKabupaten: null,
      dataKecamatan: [],
      dataJenisDokumenPermohonan: [],
      ttdDirektur: [],
      ttdKetuaTim: [],
      ttdPimpinanRapat: [],
    }
  },
  methods: {
    async nextForm() {
      return await this.submitForm()
    },

    async loadDataPermohonan() {
      const id = this.$route.query.id_pemutakhiran
      if (!id) {
        this.$router.push('/app/perubahan')
        return
      }

      const res = await axios.get(
        `${this.baseapi}api/pemuktahiran/${id}`,
        this.getApiOption(),
      )
      const resPemutakhiran = res.data.data

      const jenisPermohonan = resPemutakhiran.jenis_permohonan
      const nomorIzin = resPemutakhiran.nomor_izin_terbit
      const api =
        jenisPermohonan === 'Berusaha'
          ? `${this.baseapi}api/permohonan/dataTable?filter=nomor_oss,=,${nomorIzin}`
          : `${this.baseapi}api/permohonan_nonberusaha/dataTable?filter=nomor_kkp,=,${nomorIzin}`
      const res2 = await axios.get(api, this.getApiOption())
      const resData2 = res2.data.data[0]
      this.dataPermohonan = resData2

      // prettier-ignore
      this.form = {
        provinsi_perubahan: resPemutakhiran.provinsi_perubahan || resData2.provinsi,
        kabupaten_perubahan: resPemutakhiran.kabupaten_perubahan || resData2.kabupaten,
        kecamatan_perubahan: resPemutakhiran.kecamatan_perubahan || resData2.kecamatan,
        nama_perairan_perubahan: resPemutakhiran.nama_perairan_perubahan || resData2.nama_perairan,
        garis_pantai_perubahan: resPemutakhiran.garis_pantai_perubahan || resData2.garis_pantai,
        jenis_pnbp_perubahan: resPemutakhiran.jenis_pnbp_perubahan || resData2.jenis_pnbp,
        luas_perubahan: resPemutakhiran.luas_perubahan || resData2.luas,
        panjang_konservasi_kabel_perubahan: resPemutakhiran.panjang_konservasi_kabel_perubahan || resData2.panjang_konservasi_kabel,
        panjang_nonkonservasi_kabel_perubahan: resPemutakhiran.panjang_nonkonservasi_kabel_perubahan || resData2.panjang_nonkonservasi_kabel,
        panjang_konservasi_pipa_air_perubahan: resPemutakhiran.panjang_konservasi_pipa_air_perubahan || resData2.panjang_konservasi_pipa_air,
        panjang_nonkonservasi_pipa_air_perubahan: resPemutakhiran.panjang_nonkonservasi_pipa_air_perubahan || resData2.panjang_nonkonservasi_pipa_air,
        panjang_konservasi_pipa_lain_perubahan: resPemutakhiran.panjang_konservasi_pipa_lain_perubahan || resData2.panjang_konservasi_pipa_lain,
        panjang_nonkonservasi_pipa_lain_perubahan: resPemutakhiran.panjang_nonkonservasi_pipa_lain_perubahan || resData2.panjang_nonkonservasi_pipa_lain,
        kedalaman_perubahan: resPemutakhiran.kedalaman_perubahan || resData2.kedalaman,
        rencana_detail_kegiatan_perubahan: resPemutakhiran.rencana_detail_kegiatan_perubahan || resData2.rencana_detail_kegiatan,
      }

      // prettier-ignore
      this.formBaPentek = {
        ...this.formBaPentek,
        hasil_verifikasi_teknis: resPemutakhiran.hasil_verifikasi_teknis || null,
        ttd_ba_vertek_1: resPemutakhiran.ttd_ba_vertek_1 || null,
        ttd_ba_vertek_2: resPemutakhiran.ttd_ba_vertek_2 || null,
        ttd_ba_vertek_4: resPemutakhiran.ttd_ba_vertek_4 || null,
      }

      this.loadKoordinatPermohonan()

      if (resPemutakhiran.file_peta?.length) {
        this.file_peta_pv = resPemutakhiran.file_peta.map((d) => ({
          value: d,
          label: d.split('/').pop(),
        }))
      }
    },

    async loadKoordinatPermohonan() {
      const id_pemutakhiran = this.$route.query.id_pemutakhiran
      const res = await axios.get(
        `${this.baseapi}api/kordinat_pemuktahiran?filter=id_pemuktahiran,=,${id_pemutakhiran}&sort=createdAt,asc`,
        this.getApiOption(),
      )
      this.dataKordinat = res.data.data
    },

    async submitKoordinat() {
      await this.$validator.validateAll()
      const id_pemutakhiran = this.$route.query.id_pemutakhiran

      const formData = {
        ...this.formKoordinat,
        id_pemuktahiran: id_pemutakhiran,
      }

      try {
        this.$loading(true)
        if (!this.editKoordinatId) {
          await axios.post(
            `${this.baseapi}api/kordinat_pemuktahiran`,
            formData,
            this.getApiOption(),
          )
        } else {
          await axios.put(
            `${this.baseapi}api/kordinat_pemuktahiran/${this.editKoordinatId}`,
            formData,
            this.getApiOption(),
          )
        }
        this.$bvModal.hide('modal-koordinat')
        this.formKoordinat = {
          nama_titik: '',
          bujur: '',
          lintang: '',
        }
        this.editKoordinatId = null
        this.loadKoordinatPermohonan()
      } catch (error) {
        if (!this.editKoordinatId) {
          Swal.fire('Gagal', 'Gagal menambahkan koordinat', 'error')
        } else {
          Swal.fire('Gagal', 'Gagal edit koordinat', 'error')
        }
      } finally {
        this.$loading(false)
      }
    },

    async editKoordinat(item) {
      this.editKoordinatId = item.id
      this.formKoordinat = {
        nama_titik: item.nama_titik,
        bujur: item.bujur,
        lintang: item.lintang,
      }
      this.$bvModal.show('modal-koordinat')
    },

    async deleteKoordinat(item) {
      const { id } = item
      try {
        this.$loading(true)
        await axios.delete(
          `${this.baseapi}api/kordinat_pemuktahiran/${id}`,
          this.getApiOption(),
        )
        this.loadKoordinatPermohonan()
      } catch {
        Swal.fire('Gagal', 'Gagal menghapus koordinat', 'error')
      } finally {
        this.$loading(false)
      }
    },

    toggleModalImportKoordinat(val) {
      if (val) {
        this.$bvModal.show('modal-import-koordinat')
      } else {
        this.$bvModal.hide('modal-import-koordinat')
        this.formImportKoordinat = {
          file: null,
        }
      }
    },

    async submitImportKoordinat() {
      await this.$validator.validateAll()
      const id_pemutakhiran = this.$route.query.id_pemutakhiran

      const formData = new FormData()
      formData.append('id_pemuktahiran', id_pemutakhiran)
      formData.append('file', this.formImportKoordinat.file)

      try {
        this.$loading(true)
        await axios.post(
          `${this.baseapi}api/kordinat_pemuktahiran/import`,
          formData,
          this.getApiOption(),
        )
        this.loadKoordinatPermohonan()
        this.toggleModalImportKoordinat(false)
      } catch {
        Swal.fire('Gagal', 'Gagal import koordinat', 'error')
      } finally {
        this.$loading(false)
      }
    },

    async uploadFilePeta() {
      const file_peta = this.file_peta
      if (!file_peta || (file_peta && !file_peta.length)) {
        return
      }

      const id = this.$route.query.id_pemutakhiran

      const formData = new FormData()
      for (const [i, k] of file_peta.entries()) {
        formData.append(`file_peta[]`, k)
      }

      try {
        this.$loading(true)
        await axios.post(
          `${this.baseapi}api/pemuktahiran/setDataBaru/${id}`,
          formData,
          this.getApiOption(),
        )
        Swal.fire('Berhasil', 'Berhasil upload file peta', 'success')
        this.file_peta = null
        this.loadDataPermohonan()
      } catch (error) {
        Swal.fire('Gagal', 'Gagal upload file peta', 'error')
      } finally {
        this.$loading(false)
      }
    },

    async submitForm() {
      this.$validator.errors.clear()
      // prettier-ignore
      {
        this.manualValidation(this.form.rencana_detail_kegiatan_perubahan, 'Rencana Detail Kegiatan')
        this.manualValidation(this.formBaPentek.hasil_verifikasi_teknis, 'Hasil Analisis')
      }
      await this.$validator.validateAll()
      if (this.$validator.errors.items.length) return false

      const id = this.$route.query.id_pemutakhiran
      try {
        this.$loading(true)
        const formData = new FormData()
        for (const k in this.form) {
          if (k === 'jenis_pnbp_perubahan') continue
          if (this.form[k]) formData.append(k, this.form[k])
        }
        for (const [i, k] of this.form.jenis_pnbp_perubahan.entries()) {
          formData.append(`jenis_pnbp_perubahan[${i}]`, k)
        }

        await axios.post(
          `${this.baseapi}api/pemuktahiran/setDataBaru/${id}`,
          formData,
          this.getApiOption(),
        )

        const formData2 = new FormData()
        for (const k in this.formBaPentek) {
          if (this.formBaPentek[k]) formData2.append(k, this.formBaPentek[k])
        }

        await axios.post(
          `${this.baseapi}api/pemuktahiran/setPentek/${id}`,
          formData2,
          this.getApiOption(),
        )

        await axios.post(
          `${this.baseapi}api/pemuktahiran/${id}`,
          { status: 'Penyusunan Berita Acara Hasil Penilaian' },
          this.getApiOption(),
        )

        Swal.fire('Berhasil', 'Pemutakhiran berhasil disimpan', 'success')
        return true
      } catch (error) {
        Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
        return false
      } finally {
        this.$loading(false)
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    async getProvinsi() {
      await axios
        .get(this.baseapi + 'api/provinsi?sort=id,ASC', this.getApiOption())
        .then((response) => {
          this.dataProvinsi = response.data.data
        })
    },

    async getKabupaten(id_provinsi) {
      await axios
        .get(
          this.baseapi +
            `api/kabupaten?sort=id,ASC&filter=id_provinsi,=,${id_provinsi}`,
          this.getApiOption(),
        )
        .then((response) => {
          this.dataKabupaten = response.data.data
        })
    },

    async getKecamatan(id_kabupaten) {
      await axios
        .get(
          this.baseapi +
            `api/kecamatan?sort=id,ASC&filter=id_kabupaten,=,${id_kabupaten}`,
          this.getApiOption(),
        )
        .then((response) => {
          this.dataKecamatan = response.data.data
        })
    },

    async getJenisDokumenPermohonan() {
      await axios
        .get(this.baseapi + 'api/jenis_permohonan', this.getApiOption())
        .then((response) => {
          this.dataJenisDokumenPermohonan = response.data.data
        })
    },

    async getTtd() {
      await axios
        .get(this.baseapi + 'api/tandatangan', this.getApiOption())
        .then((response) => {
          const resData = response.data.data
          this.ttdDirektur = resData.filter((d) => d.role === 'direktur')
          this.ttdKetuaTim = resData.filter((d) => d.role === 'ketua_tim')
          this.ttdPimpinanRapat = resData
        })
    },

    manualValidation(field, name) {
      if (!field) {
        this.$validator.errors.add({
          field: name,
          msg: `${name} wajib diisi`,
        })
        return false
      } else {
        return true
      }
    },

    manualRemoveError(name) {
      this.$validator.errors.remove(name)
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },
  },
  computed: {
    itemsWithNumber() {
      return this.dataKordinat.map((d, index) => ({ ...d, no: index + 1 }))
    },
    rows() {
      return this.dataKordinat.length
    },
  },
  watch: {
    'form.provinsi_perubahan'(val) {
      const provinsi = this.dataProvinsi.find((d) => d.nama_provinsi === val)
      if (provinsi) this.getKabupaten(provinsi.id)
    },
    'form.kabupaten_perubahan'(val) {
      const kabupaten = this.dataKabupaten.find((d) => d.nama_kabupaten === val)
      if (kabupaten) this.getKecamatan(kabupaten.id)
    },
    'form.rencana_detail_kegiatan_perubahan'() {
      this.manualRemoveError('Rencana Detail Kegiatan')
    },
    'formBaPentek.hasil_verifikasi_teknis'() {
      this.manualRemoveError('Hasil Analisis')
    },
  },
  mounted() {
    this.getProvinsi()
    this.getJenisDokumenPermohonan()
    this.getTtd()
    this.loadDataPermohonan()

    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
}
</script>
